import { Link } from "react-router-dom";

/**
 * A route that does not exist.
 *
 * Says so plainly and offers the way back. It deliberately does not look like
 * an empty table -- "there is nothing here" and "there is no such page" are
 * different answers and this app does not blur them anywhere else either.
 */
export default function NotFound() {
  return (
    <div className="page">
      <div className="card">
        <div className="state">
          <div className="headline">Page not found.</div>
          <div className="detail">
            <Link to="/">Back to the dashboard</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
